import React from "react";
import { ProfileURL } from "../../../shared/profileURL";
export const SidebarSocials: React.FC = () => {
  const socials = [
    {
      name: "Github",
      url: ProfileURL.github,
    },
    {
      name: "Twitter",
      url: ProfileURL.twitter,
    },
    {
      name: "Linkedin",
      url: ProfileURL.linkedin,
    },
    {
      name: "E-Mail",
      url: ProfileURL.mail,
    },
  ];
  return (
    <div className={"px-10 py-1 hidden md:flex fixed right-[2%] top-[42%] z-[400] text-white space-x-8 text-base md:text-lg translate-x-[45%] rotate-[-90deg] bg-slate-950 border-[1px] border-slate-700/20 rounded-xl"}
    >
      {socials.map((social) => (
        <a key={social.name} target="_blank" rel="noopener noreferrer" href={social.url}
        title={`Contact on ${social.name}`}
          className="cursor-pointer uppercase text-primary-500 font-nunito"
        >
          {social.name} 
        </a>
      ))}

    </div>
  );
};
